import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

export const useWorkoutState = () => {
  const cday = localStorage.getItem("cday");
  const startDate = localStorage.getItem("wStartDate");
  const cweek = localStorage.getItem("cweek");
  const { pid, wid } = useParams();
  const widd = localStorage.getItem("workoutId");

  const [isLoading, setisLoading] = useState(false);
  const [workoutViewType, setWorkoutViewType] = useState("details");
  const [reorder, setReorder] = useState(true);
  const [keyword, setkeyword] = useState("");
  const [addType, setAddType] = useState(false);
  const [detailset, setDetailSet] = useState("");
  const [quickset, setQuickSet] = useState(false);
  const [isdisable, setisdisable] = useState(true);
  const [generalFields, setGeneralFields] = useState();
  const [cmodal, setCmodal] = useState(false);
  const [weeks, setWeeks] = useState([]);
  const [excercisemodal, setExcerciseModal] = useState(false);
  const [selectedDays, setSelectedDays] = useState(cday || []);
  const [apiexercises, setApiExercises] = useState([]);
  const [mergeexercises, setMergeExercises] = useState([]);
  const [selectedExercise, setSelectedExercise] = useState(null);
  const [selectedExerciseEmom, setSelectedExerciseEmom] = useState(null);
  const [setValues, setSetValues] = useState([]);
  const [excerciseList, setExerciseList] = useState([]);
  const [image, setImage] = useState("");
  const [isLoad, setisLoad] = useState(false);
  const [selectedFields, setSelectedFields] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);

  const [mvideo, setMvideo] = useState("");
  const [mergeId, setMergeId] = useState("");
  const [selectedimage, setSelectedimage] = useState("");
  const [newExercise, setNewExercise] = useState({
    name: "",
    video: "",
    fields: [],
  });
  const [merge, setMerge] = useState(false);
  const [removeMerge, setRemoveMerge] = useState(false);
  const [selectedExerciseIds, setSelectedExerciseIds] = useState([]);
  const [selectedExerciseremoveIds, setSelectedExerciseremoveIds] = useState([]);

  const [inputValues, setInputValues] = useState({});
  const [confirmActionModal, setConfirmActionModal] = useState(false);
  const [actionModalMessage, setActionModalMessage] = useState("");
  const [selectedActionObj, setSelectedActionObj] = useState(null);
  const [selectedActionObj2, setSelectedActionObj2] = useState(null);
  const [selectedActionObjType, setSelectedActionObjType] = useState(null);
  const [actionButtonTitle, setActionButtonTitle] = useState("OK");

  const [progress, setProgress] = useState(0);
  const [isUpLoading, setIsUpLoading] = useState(false);
  const [showVideoUploadPopup, setShowVideoUploadPopup] = useState(false);
  const [selectedVideoFile, setSelectedVideoFile] = useState(null);
  const [selectedVideoUrl, setSelectedVideoUrl] = useState("");
  const [updateVideoLinKWorkout, setUpdateVideoLinKWorkout] = useState(false);

  const [workoutData, setWorkoutData] = useState({
    days: cday || "",
    start_date: startDate || "",
    group_id: "",
    image: "",
    date: "",
    duration: "",
    workout_type: "",
    week: cweek || "",
    video: "",
    exercises: [],
    program_id: "",
    end_date: "",
    name: "",
    desc: "",
    schedule_type:"fixed"
  });

  const [workoutExercise, setWorkoutExercise] = useState({
    workout_id: wid || widd,
    program_id: pid,
    exercises: [],
  });

  useEffect(() => {
    if (cday && startDate) {
      localStorage.removeItem("cday");
      localStorage.removeItem("wStartDate");
    }
  }, [cday, startDate]);

  useEffect(() => {
    setWorkoutData((prevData) => ({
      ...prevData,
      program_id: pid,
    }));
  }, [pid]);

  return {
    // Parameters
    pid,
    wid,
    widd,
    
    // Loading states
    isLoading,
    setisLoading,
    isLoad,
    setisLoad,
    isUpLoading,
    setIsUpLoading,
    progress,
    setProgress,
    
    // UI states
    workoutViewType,
    setWorkoutViewType,
    reorder,
    setReorder,
    addType,
    setAddType,
    detailset,
    setDetailSet,
    quickset,
    setQuickSet,
    isdisable,
    setisdisable,
    
    // Modal states
    cmodal,
    setCmodal,
    excercisemodal,
    setExcerciseModal,
    merge,
    setMerge,
    removeMerge,
    setRemoveMerge,
    confirmActionModal,
    setConfirmActionModal,
    showVideoUploadPopup,
    setShowVideoUploadPopup,
    
    // Data states
    weeks,
    setWeeks,
    selectedDays,
    setSelectedDays,
    apiexercises,
    setApiExercises,
    mergeexercises,
    setMergeExercises,
    selectedExercise,
    setSelectedExercise,
    selectedExerciseEmom,
    setSelectedExerciseEmom,
    setValues,
    setSetValues,
    excerciseList,
    setExerciseList,
    generalFields,
    setGeneralFields,
    
    // Form data
    workoutData,
    setWorkoutData,
    workoutExercise,
    setWorkoutExercise,
    newExercise,
    setNewExercise,
    inputValues,
    setInputValues,
    
    // File handling
    image,
    setImage,
    selectedFile,
    setSelectedFile,
    selectedimage,
    setSelectedimage,
    selectedVideoFile,
    setSelectedVideoFile,
    selectedVideoUrl,
    setSelectedVideoUrl,
    updateVideoLinKWorkout,
    setUpdateVideoLinKWorkout,
    
    // Exercise selection
    selectedFields,
    setSelectedFields,
    selectedExerciseIds,
    setSelectedExerciseIds,
    selectedExerciseremoveIds,
    setSelectedExerciseremoveIds,
    
    // Search and filtering
    keyword,
    setkeyword,
    
    // Merge functionality
    mvideo,
    setMvideo,
    mergeId,
    setMergeId,
    
    // Action modal
    actionModalMessage,
    setActionModalMessage,
    selectedActionObj,
    setSelectedActionObj,
    selectedActionObj2,
    setSelectedActionObj2,
    selectedActionObjType,
    setSelectedActionObjType,
    actionButtonTitle,
    setActionButtonTitle,
  };
};
